import { domainUrl } from '../constants';

export const API_GET_POST_BRANCH = `${domainUrl}branches`;
